module.exports = __webpack_public_path__ + "fonts/Graphik-ThinItalic.d3fca381.ttf";